import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EditOutlined, UserOutlined } from '@ant-design/icons';

// ============================================================================
// COMPONENTES LOCAIS
// ============================================================================
import PageContainer from 'modules/account/components/PageContainer/PageContainer';

// ============================================================================
// UTILITÁRIOS E CONFIGURAÇÕES
// ============================================================================
import { RouteEnum } from '../../constantes/RouteEnum';

// ============================================================================
// ESTILOS
// ============================================================================
import { ButtonsContainer, StyledButton } from './InvitationChoice.styles';

// ============================================================================
// COMPONENTE
// ============================================================================

const InvitationChoice: React.FC = () => {
  const navigate = useNavigate();

  const handleHasCode = () => {
    navigate(RouteEnum.INVITATION);
  };

  const handleGoToRegister = () => {
    navigate(RouteEnum.LOGIN_USERNAME);
  };

  return (
    <PageContainer title="você recebeu um código de convite?" navigateBack="/">
      <ButtonsContainer>
        <StyledButton onClick={handleHasCode} type="default">
          <EditOutlined color="var(--colorTextSecondary)" />
          Sim, tenho um código.
        </StyledButton>
        <StyledButton onClick={handleGoToRegister} type="default">
          <UserOutlined color="var(--colorTextSecondary)" />
          Apenas me leve para o cadastro
        </StyledButton>
      </ButtonsContainer>
    </PageContainer>
  );
};

export default InvitationChoice;
